<template>
    <div class="myCardWrap">
        <div class="myCardTopHead">
            <img src="../assets/yjfLogo.png" alt="">
            <div>
                <p>{{getPhoneNum}}</p>
                <p>山东移动</p>
            </div>
        </div>
        <div class="myCardTopFooter">
            <p>我的票券</p>
            <div class="myCardTopFooterCon">
                <ul>
                    <li v-for = "( item, index ) in listArr" :key = 'index'>
                        <img :src="item.itemInfo.picUrl" alt="">
                        <div>
                            <div>
                                <p>{{item.itemInfo.name}}</p>
                                <p>有效期：{{item.expireTime}}</p>
                            </div>
                            <h2>
                                <img v-if="item.status == 2" @click="goCodeDetail(item.orderNo,item.status)" class="imgOne" src="../assets/use.png" alt="">
                                <img v-if="item.status == 4"  class="imgTwo" src="../assets/dateOut.png" alt="">
                                <img v-if="item.status == 3" @click="goCodeDetail(item.orderNo,item.status)" class="imgTwo" src="../assets/userOut.png" alt="">
                            </h2>
                        </div>
                        <h4 v-if="item.status == 4"></h4>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            token: '',
            listArr: [],
            getPhoneNum: ''
        }
    },
    computed: {
    },
    mounted() {
        this.token = this.$route.query.token
        if(JSON.parse(this.$cookies.get('userInfo'))) {
            var userInfo =JSON.parse(this.$cookies.get('userInfo')).split('&')
            if(userInfo.length == 4 ) {
                this.getPhoneNum = userInfo[3].split('=')[1]
                this.init()
            } else {
                this.getPhone()
            }
        } else {
            this.getPhone()
        }
    },
    methods: {
        //获取用户手机号
        getPhone(){
            this.$axios({
                method: 'post',
                url: this.GLOBAL.pro + '/shop/sdplatform/getPlatformUser?token='+ this.token,
                headers: {
                    "Content-Type": "application/json", //设置请求头请求格式为JSON
                    'token': this.token
                },
            }).then(res => {
                this.getPhoneNum = res.data.result.mobile
                this.init()
            }).catch(e => {
                console.log(e);
            });
        },
        //初始列表
        init() {
            this.$axios({
                method: 'post',
                url: this.GLOBAL.pro + '/shop/sdorder/getOrderList?token='+ this.token,
                headers: {
                    "Content-Type": "application/json", //设置请求头请求格式为JSON
                    'token': this.token
                },
            }).then(res => {
                this.listArr = res.data.result
            }).catch(e => {
                console.log(e);
            });
        },
        goCodeDetail(orderNo,status) {
            this.$router.push('/cardInfo?orderNo=' + orderNo +'&token=' + this.token + '&status=' + status)
        },
    }
}
</script>
<style lang="sass" scoped>
.myCardWrap 
    width: 100%;
    height: 100vh;  
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: url('../assets/bg.png') no-repeat;
    background-size: 100% 3rem;
    background-position-y: 0.2rem;
    .myCardTopHead
        display: flex;
        height: auto;
        width: 100%;
        padding: .4rem 0 0.2rem 0.2rem;
        img 
            width: 0.7rem;
            height: 0.7rem;
            background: #fff;
            margin-right: 0.2rem;
        >div
            height: 0.8rem;
            p
                font-size: 0.16rem;
                font-weight: bolder;
                margin-top: 0.13rem;
    .myCardTopFooter
        width: 95%;
        flex: 1;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        >p
            margin-top: 0.1rem;
            margin-bottom: 0.05rem;
            font-size: 0.17rem;
            color: #6D6D6D;
            padding-left: 0.1rem;
        .myCardTopFooterCon
            flex: 1;
            width: 100%;
            padding: 0 0.1rem;
            overflow: auto;
            ul
                width: 100%;
                height: auto;
                li
                    width: 100%;
                    height: 0.8rem;
                    overflow: hidden;
                    background: #fff;
                    box-shadow: 0 0 0.05rem 0.02rem rgba(0,0,0,0.2); 
                    margin-top: 0.05rem;
                    margin-bottom: 0.12rem;
                    border-radius: 0.05rem;
                    display: flex;
                    position: relative;
                    h4
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: rgba(255,255,255,.4);
                        width: 100%;
                        height: 100%;
                    img
                        width: 0.8rem;
                        height: 0.8rem;
                        display: block;
                        margin-right: 0.1rem;
                    >div
                        flex: 1;
                        height: 0.7rem;
                        display: flex;
                        justify-content: space-between;
                        >div
                            flex: 1;
                            height: 0.7rem;
                            margin-top: 0.05rem;
                            >p
                                width: 1.7rem;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;
                                line-height: 0.3rem;
                                font-size: 0.13rem;
                                font-weight: bold;
                        >h2
                            width: 0.7rem;
                            height: 0.8rem;
                            img
                                display: block;
                            .imgOne
                                width: auto;
                                height: 0.6rem;
                                margin: 0 auto;
                                margin-top: 0.1rem;
                            .imgTwo
                                width: auto;
                                height: 0.5rem;
                                margin: 0 auto;
                                margin-top: 0.15rem;
                                
                
</style>


// WEBPACK FOOTER //
// src/page/myCard.vue